import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Controller, Control } from 'react-hook-form';

interface FormInputBoxProps extends Omit<TextFieldProps, 'name' | 'defaultValue'> {
  name: string;
  control: Control<any>;
  label?: string;
  type?: string;
  placeholder?: string;
  defaultValue?: unknown;
}

export default function FormInputBox({ name, control, label, type = 'text', placeholder, defaultValue = '', fullWidth = true, size = 'small', ...textFieldProps }: FormInputBoxProps) {
  const customStyle = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: 'transparent',
    },
  };
  return <Controller name={name} control={control} render={({ field, fieldState }) => <TextField {...field} label={label} type={type} placeholder={placeholder} fullWidth={fullWidth} size={size} sx={customStyle} error={!!fieldState.error} helperText={fieldState.error?.message} {...textFieldProps} />} />;
}
